<div *ngIf="userProfile">
  <button
    [disabled]="isDownloadEnabled === false"
    mat-raised-button
    class="cta-button"
    [matMenuTriggerFor]="downloads"
    color="primary"
    type="button"
  >
    <span>Download</span>
    <mat-icon class="mat-ligature-font" aria-hidden="true"
      >keyboard_arrow_down</mat-icon
    >
  </button>

  <mat-menu #downloads="matMenu">
    <ng-container *ngIf="(templateTypes?.length ?? 0) > 0; else singleTemplate">
      <button
        *ngFor="let template of templateTypes"
        mat-menu-item
        type="button"
        (click)="emitDownload(template)"
      >
        Download Profile (DOCX)
      </button>
    </ng-container>

    <ng-template #singleTemplate>
      <button mat-menu-item type="button" (click)="emitDownload('')">
        Download Profile (DOCX)
      </button>
    </ng-template>
  </mat-menu>
</div>
